/* eslint-disable max-lines-per-function */
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Modal from '../../components/popup/Modal'
import { getGioiTinh } from '../../constant/gioiTinh'
import { phoiDefault } from '../../constant/PhoiDefault'
import donViDangKyDuThiProcessor from '../../processor/donViDangKyDuThiProcessor'
import hinhThucDaoTaoProcessor from '../../processor/hinhThucDaoTaoProcessor'
import khoaThiProcessor from '../../processor/khoaThiProcessor'
import namProcessor from '../../processor/namProcessor'
import phoiProcessor from '../../processor/phoiProcessor'
import vanBangProcessor from '../../processor/vanBangProcessor'
import { numberWithZero } from '../../utils/number'

const InVanBangBanSao = (props) => {
  const [phois, setPhois] = useState([])
  const [phoi, setPhoi] = useState({})
  const { visible, toggle, data, donVi } = props
  const [vb, setVb] = useState(null)
  const toast = useSelector((store) => store.notify.toast)

  useEffect(async () => {
    if (data && data.vanBangId) {
      const rs = await vanBangProcessor.getById(data.vanBangId)
      const dv = await donViDangKyDuThiProcessor.getbyId(rs.donViDangKyDuThiId)
      const kt = await khoaThiProcessor.getbyId(rs.khoaThiId)
      const n = await namProcessor.getbyId(kt.namId)
      const h = await hinhThucDaoTaoProcessor.getbyId(rs.hinhThucDaoTaoId)
      setVb({ ...rs, donViDangKyDuThi: dv, nam: n, hinhThucDaoTao: h })
    } else setVb(null)
    if (phois.length > 0) setPhoi(phois[0])
    else setPhoi({ ...phoiDefault })
  }, [data])
  const getPhois = async () => {
    const rs = await phoiProcessor.getAll()
    setPhois(rs)
  }
  useEffect(() => {
    getPhois()
  }, [])

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button
        label="Huỷ"
        className="p-button-secondary mr-2"
        onClick={() => {
          if (toggle) toggle()
        }}
      />
      <Button
        label="In"
        onClick={() => {
          const windowPrint = window.open('', 'PRINT', 'height=570,width=795')
          windowPrint.document.write(document.getElementById('vanbang-bansao-content').innerHTML)
          windowPrint.document.close()
          windowPrint.focus()
          windowPrint.print()
        }}
      />
    </div>
  )
  const doubleClick = (event) => {
    const element = event.target
    const initialX = event.clientX - element.offsetLeft
    const initialY = event.clientY - element.offsetTop
    let isDragging = true
    function moveElement(e) {
      if (isDragging) {
        const x = e.clientX - initialX
        const y = e.clientY - initialY
        element.style.top = `${y}px`
        element.style.left = `${x}px`
        element.style.cursor = 'grabbing'
      }
    }
    document.addEventListener('mousemove', moveElement)
    element.addEventListener('mouseup', () => {
      isDragging = false
      element.style.cursor = 'auto'
      document.removeEventListener('mousemove', moveElement)
      let { top, left } = element.style
      top = top.replaceAll('px', '')
      left = left.replaceAll('px', '')
      const val = element.getAttribute('value')
      setPhoi({ ...phoi, [`${val}Top`]: parseInt(top, 10), [`${val}Left`]: parseInt(left, 10) })
    })
  }
  const ngayTao = data ? new Date(data.ngayTao) : new Date()
  return (
    <>
      <Modal header="In" visible={visible} toggle={toggle} footer={footer} width="90%">
        <div className="flex flex-column justify-content-center">
          <p>
            Số bản cần in: <span className="text-red-500">{data && data.soBan}</span>
          </p>
          <div className="flex justify-content-between">
            <div>
              <Dropdown
                style={{ minWidth: 100 }}
                optionValue="id"
                optionLabel="name"
                placeholder="Danh sách phôi"
                value={phoi.id}
                onChange={(e) => {
                  setPhoi(phois.find((item) => item.id === e.value))
                }}
                options={phois}
                filter
                filterBy="name"
              />
            </div>
            {!phoi.id && (
              <InputText
                placeholder="Tên phôi"
                value={phoi.name}
                onChange={(e) => setPhoi({ ...phoi, name: e.target.value })}
              />
            )}
            <div>
              <Button
                style={{ width: 80 }}
                label="Lưu"
                className="p-button-success mr-2"
                onClick={async () => {
                  if (!phoi.name) {
                    toast({ type: 'error', message: 'Tên không được để trống' })
                    return
                  }
                  const rs = await phoiProcessor.upsert(phoi)
                  if (phoi.id) {
                    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
                  } else {
                    if (rs.isSuccess) setPhoi({ ...phoi, id: parseInt(rs.data, 10) })
                    toast({
                      type: rs.isSuccess ? 'success' : 'error',
                      message: rs.isSuccess ? 'Thêm mới thành công' : rs.data,
                    })
                  }
                  if (rs.isSuccess) getPhois()
                }}
              />
              <Button
                style={{ width: 80 }}
                label="Phôi mới"
                className="p-button-info mr-2"
                onClick={() => {
                  setPhoi({ ...phoiDefault })
                }}
              />
              <Button
                style={{ width: 80 }}
                label="Huỷ"
                className="p-button-warning mr-2"
                onClick={() => {
                  if (phois.length > 0) setPhoi(phois[0])
                  else setPhoi({ ...phoiDefault })
                }}
              />
              <Button
                style={{ width: 80 }}
                label="Xoá"
                className="p-button-danger"
                onClick={async () => {
                  if (!phoi.id) {
                    toast({ type: 'error', message: 'Phôi không tồn tại' })
                    return
                  }
                  const rs = await phoiProcessor.delete(phoi.id)
                  toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
                  getPhois()
                  if (phois.length > 0) setPhoi(phois[0])
                  else setPhoi({ ...phoiDefault })
                }}
              />
            </div>
          </div>
          <p>Nội dung:</p>
          <div className="flex justify-content-center">
            <section className="print" id="vanbang-bansao-content">
              <div
                className="inner-content"
                style={{
                  fontFamily: 'Times New Roman',
                  color: 'black',
                  position: 'relative',
                  height: '148mm',
                  width: '209mm',
                }}
              >
                {vb && (
                  <>
                    <b
                      className="print-content"
                      value="hoTen"
                      style={{ top: phoi.hoTenTop, left: phoi.hoTenLeft, position: 'absolute' }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {vb.hoTen}
                    </b>
                    <b
                      className="print-content"
                      value="ngaySinh"
                      style={{
                        top: phoi.ngaySinhTop,
                        left: phoi.ngaySinhLeft,
                        position: 'absolute',
                      }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {vb.ngaySinh}
                    </b>
                    <b
                      className="print-content"
                      value="noiSinh"
                      style={{ top: phoi.noiSinhTop, left: phoi.noiSinhLeft, position: 'absolute' }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {vb.noiSinh}
                    </b>
                    <b
                      className="print-content"
                      value="gioiTinh"
                      style={{
                        top: phoi.gioiTinhTop,
                        left: phoi.gioiTinhLeft,
                        position: 'absolute',
                      }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {getGioiTinh(vb.gioiTinh)}
                    </b>
                    <b
                      className="print-content"
                      value="danToc"
                      style={{ top: phoi.danTocTop, left: phoi.danTocLeft, position: 'absolute' }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {vb.danToc}
                    </b>
                    <b
                      className="print-content"
                      value="donViDangKyDuThi"
                      style={{
                        top: phoi.donViDangKyDuThiTop,
                        left: phoi.donViDangKyDuThiLeft,
                        position: 'absolute',
                      }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {vb.donViDangKyDuThi.name}
                    </b>
                    <b
                      className="print-content"
                      value="nam"
                      style={{ top: phoi.namTop, left: phoi.namLeft, position: 'absolute' }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {vb.nam.name}
                    </b>
                    <b
                      className="print-content"
                      value="xepLoaiTop"
                      style={{ top: phoi.xepLoaiTop, left: phoi.xepLoaiLeft, position: 'absolute' }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {vb.xepLoai}
                    </b>
                    <b
                      className="print-content"
                      value="hinhThucDaoTao"
                      style={{
                        top: phoi.hinhThucDaoTaoTop,
                        left: phoi.hinhThucDaoTaoLeft,
                        position: 'absolute',
                      }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {vb.hinhThucDaoTao.name}
                    </b>
                    <p
                      className="print-content"
                      value="donVi1"
                      style={{ top: phoi.donVi1Top, left: phoi.donVi1Left, position: 'absolute' }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {donVi}
                    </p>
                    <p
                      className="print-content"
                      value="ngayTaoDate"
                      style={{
                        top: phoi.ngayTaoDateTop,
                        left: phoi.ngayTaoDateLeft,
                        position: 'absolute',
                      }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {numberWithZero(ngayTao.getDate(), 2)}
                    </p>
                    <p
                      className="print-content"
                      value="ngayTaoMonth"
                      style={{
                        top: phoi.ngayTaoMonthTop,
                        left: phoi.ngayTaoMonthLeft,
                        position: 'absolute',
                      }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {numberWithZero(ngayTao.getMonth() + 1, 2)}
                    </p>
                    <p
                      className="print-content"
                      value="ngayTaoYear"
                      style={{
                        top: phoi.ngayTaoYearTop,
                        left: phoi.ngayTaoYearLeft,
                        position: 'absolute',
                      }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {numberWithZero(ngayTao.getFullYear(), 2)}
                    </p>
                    <b
                      className="print-content"
                      value="donVi2"
                      style={{
                        top: phoi.donVi2Top,
                        left: phoi.donVi2Left,
                        position: 'absolute',
                        fontSize: 16,
                      }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {donVi}
                    </b>
                    <b
                      className="print-content"
                      value="soVaoSo"
                      style={{ top: phoi.soVaoSoTop, left: phoi.soVaoSoLeft, position: 'absolute' }}
                      onDoubleClick={doubleClick}
                      draggable
                    >
                      {data.soVaoSo}
                    </b>
                  </>
                )}
              </div>
            </section>
          </div>
        </div>
      </Modal>
    </>
  )
}
export default InVanBangBanSao
